import React, { useEffect, useState } from 'react';

import { View } from 'react-native';

import FastImage from 'react-native-fast-image';
import Animated, {
    interpolate,
    useAnimatedStyle,
    useSharedValue,
    withTiming,
} from 'react-native-reanimated';

import NagraImage from 'components/NagraImage';
import {
    AspectRatio,
    ImageContentType,
    ImageSize,
    ImageType,
} from 'components/NagraImage/types';

import styles from './styles';

type Props = {
    channelId: string;
};

function ZappingChannelLogo({ channelId }: Props) {
    const [logos, setLogos] = useState<{
        firstLogo: string;
        secondLogo: string;
    }>({
        firstLogo: channelId,
        secondLogo: channelId,
    });

    const sharedOpacity = useSharedValue(1);

    const firstLogoOpacityStyle = useAnimatedStyle(() => {
        return {
            opacity: sharedOpacity.value,
        };
    }, []);
    const secondLogoOpacityStyle = useAnimatedStyle(() => {
        return {
            opacity: interpolate(sharedOpacity.value, [0, 1], [1, 0]),
        };
    }, []);

    useEffect(() => {
        if (channelId !== logos.firstLogo || channelId !== logos.secondLogo) {
            if (sharedOpacity.value === 1) {
                setLogos((_state) => ({
                    ..._state,
                    secondLogo: channelId,
                }));
                sharedOpacity.value = withTiming(0, { duration: 300 });
            } else {
                setLogos((_state) => ({
                    ..._state,
                    firstLogo: channelId,
                }));
                sharedOpacity.value = withTiming(1, { duration: 300 });
            }
        }
    }, [channelId]);

    return (
        <View style={styles.root} pointerEvents="none">
            <Animated.View
                style={[styles.channelLogoWrapper, firstLogoOpacityStyle]}
                pointerEvents="none"
            >
                <NagraImage
                    style={styles.channelLogo}
                    cache={FastImage.cacheControl.immutable}
                    priority={FastImage.priority.high}
                    contentId={logos.firstLogo}
                    contentType={ImageContentType.CHANNEL}
                    imageType={ImageType.LOGO}
                    aspect={AspectRatio.LANDSCAPE}
                    width={ImageSize.ZAPPING_OVERLAY_CHANNEL_LOGO.width}
                    resizeMode="contain"
                />
            </Animated.View>
            <Animated.View
                style={[styles.channelLogoWrapper, secondLogoOpacityStyle]}
                pointerEvents="none"
            >
                <NagraImage
                    style={styles.channelLogo}
                    cache={FastImage.cacheControl.immutable}
                    priority={FastImage.priority.high}
                    contentId={logos.secondLogo}
                    contentType={ImageContentType.CHANNEL}
                    imageType={ImageType.LOGO}
                    aspect={AspectRatio.LANDSCAPE}
                    width={ImageSize.ZAPPING_OVERLAY_CHANNEL_LOGO.width}
                    resizeMode="contain"
                />
            </Animated.View>
        </View>
    );
}

export default ZappingChannelLogo;
